import { render, staticRenderFns } from "./Pozo.vue?vue&type=template&id=dbca2466&"
import script from "./Pozo.vue?vue&type=script&lang=js&"
export * from "./Pozo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports